// Tracking
import { ampli } from "ampli";

export default class Http {
  static retryCount = 0;
  static RETRY_LIMIT = 2;

  static get(url) {
    return Http._fetchMethod(url);
  }

  static post({ url, data = null, excludeApiPrefix = false }) {
    return Http._fetchMethod({ method: "POST", url, data, excludeApiPrefix });
  }

  static async _fetchMethod({ data = null, method = "GET", url = "", excludeApiPrefix = false }) {
    const API_HOST = process.env.REACT_APP_API_URL;
    const relatedUrl = excludeApiPrefix ? `/${url}` : `/api/v1/${url}`;
    const fullUrl = API_HOST ? API_HOST + relatedUrl : relatedUrl;

    const fetchBody = data && { body: JSON.stringify(data) };

    const response = await fetch(fullUrl, {
      method,
      headers: { "Content-Type": "application/json" },
      ...fetchBody,
    });

    const responseData = await Http._handleAPIResponse(response);

    if (response.ok) {
      return { status: response.status, success: true, ...responseData };
    }

    switch (response.status) {
      case 400:
        return { status: response.status, success: false, ...responseData };

      case 423:
        return {
          isTemporaryLocked: true,
          status: response.status,
          success: false,
          ...responseData,
        };

      case 424:
        return { status: response.status, success: false, ...responseData };

      default:
        if (this.retryCount >= this.RETRY_LIMIT) {
          this.retryCount = 0;

          const { error } = responseData;
          if (error) {
            const { message: errorMessage, source: errorDetails } = error;
            Http._handleItlyError({ errorDetails, errorMessage, errorStatus: response.status });
          }

          return { error: true, status: response.status, success: false };
        }

        this.retryCount++;
        return Http._fetchMethod({ method, url, data });
    }
  }

  static async _handleAPIResponse(response) {
    try {
      return await response.json();
    } catch {
      return {};
    }
  }

  static _handleItlyError(info) {
    ampli.errorEncountered({
      error_code: info.errorDetails,
      error_message: info.errorMessage,
      error_status: info.errorStatus,
    });
  }
}
